export const ServiceProviderTypes = {
  Architect: 'Architect',
  ConstructionProjectManager: 'Construction Project Manager',
  Consultant: 'Consultant',
  Landlord: 'Landlord',
  PropertyManager: 'Property Manager',
  Contractor: 'Subcontractor',
  Client: 'Client',
  GeneralContractor: 'General Contractor',
};

export const ServiceProviderOptions = Object.keys(ServiceProviderTypes)
  .filter((type) => type !== 'GeneralContractor' && type !== 'Client')
  .map((type) => {
    return { value: type, label: ServiceProviderTypes[type] };
  });

export const ServiceProviderOptionsUrl = Object.values(
  ServiceProviderTypes
).map((type) => type.toLowerCase().split(' ').join('-'));

export const ServiceProviderOptionsUrlToValues = new Map(
  ServiceProviderOptionsUrl.map((value, indx) => [
    value,
    Object.keys(ServiceProviderTypes)[indx],
  ])
);

export const ServiceProviderValuesToUrl = new Map(
  Array.from(ServiceProviderOptionsUrlToValues, (a) => a.reverse())
);

export const ServiceProviderTitles = {
  Client: ['Administrator'],
  GeneralContractor: [
    'Co-Founder',
    'Project Executive',
    'Senior Project Manager',
    'Project Manager',
    'Senior Project Administrator',
    'Business Manager',
    'Project Engineer',
    'Senior Superintendent',
    'Superintendent',
    'Assistant Superintendent',
    'Field Operations Manager',
    'Administrator',
    'Laborer',
  ],
  Architect: [
    'Principal',
    'Designer',
    'Senior Associate',
    'Associate',
    'Studio Director',
    'Project Manager',
    'Administrator',
  ],
  ConstructionProjectManager: [
    'Executive',
    'Project Manager',
    'Project Engineer',
    'Field Operations',
    'Administrator',
  ],
  Consultant: ['MEP', 'AV', 'Structural'],
  Landlord: ['Executive', 'Associate', 'Building Manager', 'Administrator'],
  PropertyManager: [
    'Property Manager',
    'Assistant Property Manager',
    'Building Engineer',
    'Administrator',
  ],
  Contractor: [
    'President',
    'Vice President',
    'Executive',
    'Project Manager',
    'Assistant Project Manager',
    'Project Engineer',
    'Estimator',
    'Superintendent',
    'Assistant Superintendent',
    'Foreman',
    'Administrator',
  ],
};



// WEBPACK FOOTER //
// ./src/domain/service-provider-type-enum.js